/**
 * Auto BCC for Gmail by cloudHQ
 *
 * Its single web-accessible-resource entry — javascripts/*, icons/* and stylesheets/* —
 * is matched to cloudhq.net and mail.google.com only. Nothing scopes it to an arbitrary
 * page, so those resources are unreachable elsewhere and a negative from any other
 * origin says nothing. (The javascripts glob matches no file in the shipped package, so
 * probing rests on the icon and stylesheet paths.)
 *
 * From a matching origin the resources are static (no use_dynamic_url) at a fixed URL,
 * so a fetch of the vendor-named main_gmail_auto_bcc.css is conclusive.
 *
 * Manifest verified against version 1.0.2.7.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bfhaienophdigbdknjamfcbhinmmnbha';

export const autoBccForGmail: ExtensionDefinition = {
  id: ID,
  name: 'Auto BCC for Gmail™ by cloudHQ',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://www.cloudhq.net',
  notes:
    'WAR scoped to cloudhq.net and mail.google.com, so only those sites can detect it. ' +
    'The resources are static, so a single fetch of a vendor-named path is conclusive.',
  signals: [
    {
      id: 'war-main-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch stylesheets/main_gmail_auto_bcc.css — a vendor-named stylesheet, static and ' +
        'scoped to the matching origins.',
      weight: 1,
      run: () => probeFetch(ID, 'stylesheets/main_gmail_auto_bcc.css'),
    },
    {
      id: 'war-gmail-icon',
      kind: 'web-accessible-resource',
      description: 'Fetch icons/gmail_auto_bcc_icon.png — a vendor-named icon, a second scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/gmail_auto_bcc_icon.png'),
    },
    {
      id: 'war-auto-bcc-icon',
      kind: 'web-accessible-resource',
      description: 'Fetch icons/auto_bcc_icon.png — a third vendor-named scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'icons/auto_bcc_icon.png'),
    },
  ],
};
